<template>
	<b-modal
		v-if="taskView"
		v-model="openModal"
		@hidden="closeModal"
		scrollable
		hide-header
		body-class="container-modal"
		centered
		hide-footer
	>
		<div class="icon-close">
			<button @click="closeModal" class="btn btn-primary">
				<FeatherIcon icon="XIcon" class="font-weight-bolder" size="22" />
			</button>
		</div>
		<div class="grid-modal-calendar">
			<div class="d-flex justify-content-center mt-1">
				<div
					:style="{
						background: `${taskView ? taskView.colors.color : '#fff'}`,
					}"
					class="circle"
				/>
			</div>
			<div class="w-100">
				<h3 class="ml-50">{{ taskView ? `Torneo | ${taskView.title}` : "" }}</h3>
				<div class="d-flex align-items-center justify-content-between mt-1">
					<div class="">
						<strong class="m-0 font-small-4">
							{{ month ? month.name : null }},
							{{ numberDay ? numberDay : null }}
							{{ day ? day.name : null }} {{ taskView.time.substr(-8, 5) }}
						</strong>
						<p class="mb-0 font-small-3 font-weight-bold" v-if="taskView.future">Sin clasificar aún</p>
					</div>
					<b-button target="_blank" class="" :href="taskView.link" variant="outline-primary">
						Ver torneo
					</b-button>
				</div>
			</div>
		</div>

		<div class="container-grid-modal-tournament">
			<div v-if="taskView.battle" class="grid-modal-calendar grid-border-modal">
				<div class="d-flex justify-content-center mb-1 icon-flex">
					<feather-icon icon="WindIcon" size="18" />
				</div>
				<div>
					<h5>Batalla</h5>
					<p class="description-text font-small-3 m-0">
						{{ taskView.battle }}
					</p>
				</div>
			</div>
			<div v-if="taskView.coliseum" class="grid-modal-calendar grid-border-modal">
				<div class="d-flex justify-content-center mb-1 icon-flex">
					<svg width="18" height="18" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
						<path
							fill="currentColor"
							d="M152.39 77.82c-49.333 15.867-93.323 45.849-114.356 85.986 13.498-.909 10.582 14.516 10.582 29.947H35.133c.299 20.005 4.471 22.494 4.471 22.494 8.813 0 8.813 16 8.813 32H31.576L21 410.247c0 2.752 3.504 5.265 9.857 7.543.22-25.637 1.467-47.543 8.747-47.543 7.706 0 8.674 24.472 8.795 52.014 6.795 1.305 14.716 2.501 23.544 3.593.173-27.374 1.5-51.607 11.724-51.607 10.528 0 11.617 25.708 11.73 54.07 9.233.829 19.047 1.576 29.416 2.23.127-28.453 1.37-54.3 13.687-54.3 12.527 0 13.596 26.746 13.69 55.772 8.306.378 16.815.712 25.5.994.132-28.636 1.492-54.766 15.643-54.766 14.282 0 17.254 8 17.365 36.943 27.602 20.197 24.014 14.35 27.7 18.983.115-29.085 1.467-55.926 17.602-55.926 16.136 0 17.487 26.846 17.602 55.934 9.875-.068 19.698-.194 29.419-.375.112-28.944 1.364-55.559 15.646-55.559 14.15 0 15.51 26.127 15.643 54.76a1988.66 1988.66 0 0 0 20.588-.764l-34.499-77.27-30.497-2.595-24.543-113.03-35.274 2.962-13.024-52.692-15.948-2.326zm-13.691 45.933c13.708 0 13.708 16 13.708 32l-27.416 8c0-16 0-40 13.708-40zm-54.833 16c11.75 0 11.75 16 11.75 32l-23.5 4c0-16 0-36 11.75-36zm109.467 60.494c15.667 0 15.667 16 15.667 32l-31.333 2c0-16 0-34 15.666-34zm-54.833 4c13.708 0 13.708 16 13.708 32l-27.416 2c0-16 0-34 13.708-34zm-54.833 6c11.75 0 11.75 16 11.75 32l-23.5 4c0-16 0-36 11.75-36zm199.323 27.147l20.012 92.175c0-23.77.146-47.322 15.665-47.322 15.666 0 15.666 24 15.666 48-1.437 5.715-1.537 6.167-2.18 7.664l28.683 64.244c1.412-15.195 4.743-25.908 12.664-25.908 12.316 0 13.56 25.846 13.687 54.299 9.64-.609 18.791-1.3 27.457-2.059.11-28.43 1.182-54.24 11.731-54.24 10.253 0 11.559 24.37 11.725 51.84 10.484-1.26 19.768-2.66 27.463-4.211.129-27.382 1.122-51.629 8.791-51.629 7.21 0 8.501 21.485 8.74 46.797 5.109-2.078 7.906-4.342 7.906-6.797l-9.013-138.066c-10.884-10.001-26.092-16.875-44.141-21.692l-19.893 14.002-30.259-2.808-20.7-21.143c-27.077-1.717-55.883-2.184-84.004-3.146zm-89.657 44.853c15.667 0 15.667 24 15.667 48h-31.333c0-24 0-48 15.666-48zm62.667 0c17.625 0 17.625 24 17.625 48h-35.25c0-24 0-48 17.625-48zm-117.5 2c13.708 0 13.708 24 13.708 48h-27.416c0-24 0-48 13.708-48zm235 0c13.708 0 13.708 24 13.708 48h-27.416c0-24 0-48 13.708-48zm-289.833 2c11.75 0 11.75 22 11.75 46l-23.5 2c0-24 0-48 11.75-48zm342.708 0c11.75 0 11.75 24 11.75 48l-23.5-2c0-24 0-46 11.75-46zm-382.77 2c8.812 0 8.812 22 8.812 46l-17.625 2c0-24 0-48 8.812-48zm426.75 0c8.812 0 8.812 24 8.812 48l-17.625-2c0-24 0-46 8.812-46z"
						/>
					</svg>
				</div>
				<div>
					<h5>Coliseo</h5>
					<p class="description-text font-small-3 m-0">
						{{ taskView.coliseum }}
					</p>
				</div>
			</div>
			<div
				v-if="taskView && taskView.fronts.length > 0"
				class="grid-modal-calendar grid-border-modal grid-modal-calendar-fronts"
			>
				<div class="d-flex justify-content-center mb-1 icon-flex">
					<feather-icon icon="CalendarIcon" size="18" />
				</div>
				<div>
					<h5>Frentes: {{ taskView.fronts.length }}</h5>
					<div class="grid-fronts-modal-calendar">
						<div
							v-for="(front, index) in taskView.fronts"
							:key="front.front_id"
							class="front-item-modal d-flex align-items-center justify-content-between"
						>
							<feather-icon
								class="icon-enroll cursor-pointer text-warning"
								icon="Edit2Icon"
								size="15"
								@click="openModalEditTournamentFront(front)"
							/>
							<p class="text-rooster-front title-front text-front-item">
								<span class="label font-small-3">Frente</span>
								<span>{{ index + 1 }}</span>
							</p>
							<div class="flex-grow-1 d-flex align-items-center justify-content-end">
								<div class="d-flex align-items-center mr-1 ml-1">
									<p class="m-0 text-rooster-front text-front-item">
										<span class="label font-small-3">Gallos:</span>
										<span class="font-weight-bold font-small-3">{{ front.rooster_quantity }}</span>
									</p>
								</div>

								<div class="d-flex align-items-center mr-1 ml-1">
									<p class="m-0 text-rooster-front text-front-item">
										<span class="label font-small-3">Por llevar:</span>
										<span class="font-weight-bold font-small-3">
											{{ front.rooster_quantity_to_carry }}
										</span>
									</p>
								</div>

								<div class="icon-plus-add-fronts">
									<feather-icon
										class="text-white cursor-pointer"
										icon="PlusIcon"
										size="16"
										@click="openModalAddTournamentSpecimensToFront(front)"
									/>
								</div>
							</div>
						</div>
						<span>
							<a href="#" class="font-small-2 font-weight-bolder" @click="openModalAddFront">
								Agregar frente
							</a>
						</span>
					</div>
				</div>
			</div>
			<div
				v-if="taskView && taskView.participants && taskView.participants.length > 0"
				class="grid-modal-calendar grid-border-modal grid-modal-calendar-fronts"
			>
				<div class="d-flex justify-content-center mb-1 icon-flex">
					<feather-icon icon="UsersIcon" size="18" />
				</div>
				<div>
					<h5>{{ taskView.participants.length }} contactos</h5>
					<div class="grid-users-modal-calendar">
						<div
							v-for="(user, index) in taskView.participants"
							:key="index"
							class="user-item-modal d-flex align-items-center justify-content-between w-100"
						>
							<div class="d-flex align-items-center">
								<b-avatar size="18" />
								<p class="font-small-3 m-0 contact-name-modal-calendar">
									{{ user.name }}
								</p>
							</div>

							<div
								class="container-clipboard-modal-calendar cursor-pointer ml-1 d-flex align-content-center justify-space-between"
							>
								<feather-icon
									class="text-primary icon-clip-modal-calendar"
									icon="PhoneIcon"
									size="16"
								/>
								<a class="clip-phone-user text-primary m-0 copy-phone" :href="`tel: ${user.phone}`">
									{{ user.phone }}
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div
				v-if="taskView && taskView.description"
				class="grid-modal-calendar grid-border-modal grid-modal-calendar-fronts"
			>
				<div class="d-flex justify-content-center mb-1 icon-flex">
					<feather-icon icon="CalendarIcon" size="18" />
				</div>
				<div>
					<h5>Description</h5>
					<p class="description-text font-small-3 m-0">
						{{ taskView.description }}
					</p>
				</div>
			</div>

			<div
				v-if="taskView && taskView.createdBy"
				class="grid-modal-calendar grid-border-modal grid-modal-calendar-fronts"
			>
				<div class="d-flex justify-content-center mb-1 icon-flex">
					<feather-icon icon="FileTextIcon" size="18" />
				</div>
				<div>
					<h5>{{ "Creado por" }}</h5>
					<div class="d-flex align-items-center justify-content-between gap-x-1">
						<p class="description-text font-small-3 m-0">
							{{ taskView.createdBy.name }}
						</p>
						<div class="container-clipboard-modal-calendar d-flex align-content-center">
							<feather-icon class="text-primary icon-clip-modal-calendar" icon="MailIcon" size="16" />
							<a
								class="clip-email-usser cursor-pointer text-primary mb-0 copy-phone"
								:href="`mailto: ${taskView.createdBy.email}`"
							>
								{{ taskView.createdBy.email }}
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>

		<b-modal
			id="add-roosters-tournament-stage"
			size="xmd"
			:title="`Agregar frente a fecha ${taskView ? taskView.date : 'Por definir'}
          `"
			ok-title="Guardar"
			@ok.prevent="$refs.refAddRoostersToTournament.addRoostersToTournamentStage()"
		>
			<add-roosters-to-tournament
				ref="refAddRoostersToTournament"
				:tournamentObject="{
					tournament_id: taskView ? taskView.id_tournament : null,
				}"
				:stageObject="taskView"
				:dateId="taskView ? taskView.tournament_stage_date_id : null"
				@closeModal="closeModalAddFront"
				@changeScrollable="scrollableActive = false"
				@changeScrollableFalse="scrollableActive = true"
			></add-roosters-to-tournament>
		</b-modal>

		<b-modal
			id="modal-edit-tournament-front-now"
			ok-title="Actualizar"
			:title="`Editar frente de fecha ${taskView ? taskView.date : 'Por definir'}`"
			@ok.prevent="$refs.refEditTournamentFrontNow.updateTournamentFront()"
			size="lg"
			:scrollable="scrollableActive"
		>
			<edit-tournament-front
				ref="refEditTournamentFrontNow"
				:frontObject="selectedFront"
				@closeModal="closeModalAddFront"
				@changeScrollable="scrollableActive = false"
				@changeScrollableFalse="scrollableActive = true"
			></edit-tournament-front>
		</b-modal>

		<b-modal
			id="modal-add-roosters-tournament-stage"
			size="xl"
			ok-title="Guardar"
			@ok.prevent="$refs.refAddRoostersToTournamentStage.addRoostersToTournamentStage()"
			:scrollable="!scrollableActive"
			title="Registrar Gallos del Frente"
			no-close-on-backdrop
		>
			<add-roosters-to-tournament-stage
				ref="refAddRoostersToTournamentStage"
				:tournamentFrontId="selectedFrontId"
				:frontRoosterQuantityToCarry="selectedFrontRoosterQuantity"
				:frontRoosterQuantityExactly="selectedFrontRoosterQuantityExactly"
				:frontRoosterQuantityRegistered="selectedFrontRoosterQuantityRegistered"
				@closeModal="closeModalAddFront"
				@changeScrollable="scrollableActive = false"
				@changeScrollableFalse="scrollableActive = true"
			></add-roosters-to-tournament-stage>
		</b-modal>
	</b-modal>
</template>

<script>
import { useClipboard } from "@vueuse/core"
import AddRoostersToTournament from "../AddRoostersToTournament.vue"
import EditTournamentFront from "../components/EditTournamentFront.vue"
import TournamentService from "../tournament.service"
import AddRoostersToTournamentStage from "../AddRoostersToTournamentStage.vue"
export default {
	name: "ModalDayCalendar",
	props: {
		taskView: {
			type: Object,
			default: null,
		},
		openModalTask: {
			type: Boolean,
		},
	},
	components: {
		AddRoostersToTournament,
		EditTournamentFront,
		AddRoostersToTournamentStage,
	},
	data() {
		return {
			openModal: false,
			arrayDays: [
				{
					name: "Domingo",
					id: 0,
				},
				{
					name: "Lunes",
					id: 1,
				},
				{
					name: "Martes",
					id: 2,
				},
				{
					name: "Miercoles",
					id: 3,
				},
				{
					name: "Jueves",
					id: 4,
				},
				{
					name: "Viernes",
					id: 5,
				},
				{
					name: "Sabado",
					id: 6,
				},
			],
			arrayMonths: [
				{
					name: "Enero",
					id: 1,
				},
				{
					name: "Febrero",
					id: 2,
				},
				{
					name: "Marzo",
					id: 3,
				},
				{
					name: "Abril",
					id: 4,
				},
				{
					name: "Mayo",
					id: 5,
				},
				{
					name: "Junio",
					id: 6,
				},
				{
					name: "Julio",
					id: 7,
				},
				{
					name: "Agosto",
					id: 8,
				},
				{
					name: "Setiembre",
					id: 9,
				},
				{
					name: "Octubre",
					id: 10,
				},
				{
					name: "Noviembre",
					id: 11,
				},
				{
					name: "Diciembre",
					id: 12,
				},
			],
			month: null,
			day: null,
			numberDay: null,
			message: "Copy These Text",
			scrollableActive: false,
			modalAddTournamentController: false,
			selectedDateId: null,
			selectedStage: null,
			selectedDate: null,
			selectedFront: {},
			selectedFrontId: null,
			selectedFrontRoosterQuantity: 0,
			selectedFrontRoosterQuantityExactly: 0,
			selectedFrontRoosterQuantityRegistered: 0,
		}
	},
	//   watch: {
	//     openModalTask() {
	//       this.openModal = this.openModalTask;
	//     },
	//   },
	created() {
		if (this.taskView) {
			const date = new Date(this.taskView.date)
			date.setDate(date.getDate() + 1)
			this.month = this.arrayDays.find((item) => item.id == date.getDay())
			this.day = this.arrayMonths.find((item) => item.id == date.getMonth() + 1)
			this.numberDay = date.getDate()
			this.openModal = this.openModalTask
		}
	},
	methods: {
		closeModalAddFront() {
			this.$bvModal.hide("add-roosters-tournament-stage")
			this.$bvModal.hide("modal-edit-tournament-front-now")
			this.$bvModal.hide("modal-add-roosters-tournament-stage")
			this.getUpdatedFronts()
		},
		closeModal() {
			this.$emit("closeModal")
			this.openModal = false
		},
		openModalEditTournamentFront(front) {
			Object.assign(this.selectedFront, front)
			this.$bvModal.show("modal-edit-tournament-front-now")
		},
		openModalAddTournamentSpecimensToFront(front) {
			this.selectedFrontId = front.front_id
			this.selectedFrontRoosterQuantity = front.rooster_quantity_to_carry || 0
			this.selectedFrontRoosterQuantityRegistered = front.rooster_counter_exactly || 0
			this.selectedFrontRoosterQuantityExactly = front.rooster_quantity || 0
			this.$bvModal.show("modal-add-roosters-tournament-stage")
		},
		openModalAddFront() {
			this.$bvModal.show("add-roosters-tournament-stage")
		},
		async getUpdatedFronts() {
			const fronts = await TournamentService.getCalendarDateFronts({
				tournament_stage_date_id: this.taskView.tournament_stage_date_id,
			})
			this.taskView.fronts = fronts
		},
		doCopy(message) {
			const { copy } = useClipboard()

			copy(message)
		},
	},
}
</script>

<style lang="scss" scope>
.grid-modal-calendar {
	display: flex;
	justify-content: flex-start;
	// background: red;
	width: 100%;
	.icon-flex {
		// background: green;
		margin-right: 0.8rem;
	}
	// margin-bottom: 1rem;
	.circle {
		height: 12px;
		width: 12px;
		border-radius: 2px;
		background: #6e8192;
		margin-top: 8px;
	}
	.grid-users-modal-calendar {
		.user-item-modal {
			margin-bottom: 6px;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
	.grid-fronts-modal-calendar {
		.front-item-modal {
			margin-bottom: 6px;
			&:last-child {
				margin-bottom: 0;
			}
		}
	}
}
.icon-enroll {
	margin-right: 0.5rem;
}
.text-rooster-front {
	font-size: 11px;
	@media screen and (min-width: 600px) {
		font-size: 14px;
	}
}
.title-front {
	margin: 0 0 0 4px;
}
.copy-phone {
	font-weight: 600;
	margin-left: 0.5rem !important;
	font-size: 10px;
	@media screen and (min-width: 600px) {
		font-size: 12px;
	}
	@media screen and (min-width: 900px) {
		font-size: 13px;
	}
}
.icon-clip-modal-calendar {
	margin-top: 2px;
}
.container-clipboard-modal-calendar {
	transition: 0.2s transform ease-in-out;
	margin-left: 0.5rem;

	&:hover,
	&:active {
		transform: scale(1.025);
	}
}
.contact-name-modal-calendar {
	margin-left: 5px !important;
}
.clip-email-usser {
	width: 130px !important;
	@media screen and (min-width: 600px) {
		width: auto !important;
	}
}
.clip-phone-user {
	width: 68px !important;
	@media screen and (min-width: 600px) {
		width: auto !important;
	}
}
.text-front-item {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	@media screen and (min-width: 600px) {
		flex-direction: row;
		.label {
			margin-right: 0.5rem;
		}
	}
}
.container-grid-modal-tournament {
	margin-top: 2rem;
	display: grid;
	grid-template-columns: 1fr 1fr;
	gap: 1.25rem;
	margin-bottom: 0.5rem;
	.grid-border-modal {
		border: 1.5px solid var(--light-accent);
		border-radius: 10px;
		padding: 0.8rem;
		box-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
	}
	.grid-modal-calendar-fronts {
		// background: red;
		grid-column-start: 1;
		grid-column-end: 3;
		// border: 1px solid red;
	}
}
.container-modal {
	// background: red !important;
	// overflow: visible;
	padding: 1.75rem 1.5rem;
	overflow: visible !important;
	.icon-close {
		z-index: 2000;
		position: absolute;
		top: -36px;
		right: 0px;

		.btn {
			height: 36px !important;
			width: 36px !important;
			padding: 0;
		}
	}
}
.icon-plus-add-fronts {
	background: var(--primary);
	border-radius: 50%;
	height: 20px;
	width: 20px;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
